import React from 'react'
import { 
    ArtefactsContainer, 
    ArtefactCard,
    ArtefactWrapper,
    ArtefactsHeading,
    ArtefactsHeading1,
    ArtefactsHeading2,
    Title, 
    Desc, 
    ArtefactInfo,
    ArtefactImg
} from './BidayuhArtefacts';

import '../../../../App.css';
import {useState} from 'react'; 
import {AiOutlineMan, AiOutlineWoman} from 'react-icons/ai';
import {AiOutlineSearch} from 'react-icons/ai';
import {BsFillPersonFill} from 'react-icons/bs';
import {KenyahMenCostList, KenyahWomenCostList, KayanMenCostList, KayanWomenCostList, PenanMenCostList, PenanWomenCostList, KelabitWomenCostList, KelabitMenCostList, BisayaMenCostList, BisayaWomenCostList, LunBawangMenCostList, LunBawangWomenCostList } from './data';


const UluCostumes = (props)=> {

    const [searchTerm, setSearchTerm] = useState ("");

    return (
            <ArtefactsContainer> 
            
                <ArtefactsHeading> Orang Ulu Traditional Costumes </ArtefactsHeading>
                        <label className = "label"> <AiOutlineSearch/> Filter Arterfect </label>
                        <input className = "searchbox"
                            type = "text"
                            placeholder= " Unwrap your heritage " 
                            onChange = {(event) => {
                                setSearchTerm(event.target.value);
                            }}
                        />
                   
                    <ArtefactsHeading1> 
                         <BsFillPersonFill/> Kenyah Traditional Costumes
                    </ArtefactsHeading1>
                    
                    <ArtefactsHeading2>
                         <AiOutlineMan/> Men's Costume
                    </ArtefactsHeading2>             
                   
                    <ArtefactWrapper>                
                        {KenyahMenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
                    <ArtefactsHeading2> 
                        <AiOutlineWoman/> Women's Costumes 
                    </ArtefactsHeading2>
                     <ArtefactWrapper> 
                      {KenyahWomenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>

                    <ArtefactsHeading1> 
                         <BsFillPersonFill/> Kayan Traditional Costumes
                    </ArtefactsHeading1>
                    
                    <ArtefactsHeading2>
                         <AiOutlineMan/> Men's Costume
                    </ArtefactsHeading2>             
                   
                    <ArtefactWrapper>                
                        {KayanMenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
                    <ArtefactsHeading2> 
                        <AiOutlineWoman/> Women's Costumes 
                    </ArtefactsHeading2>
                     <ArtefactWrapper> 
                      {KayanWomenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>

                    <ArtefactsHeading1> 
                         <BsFillPersonFill/> Penan Traditional Costumes
                    </ArtefactsHeading1>
                    
                    <ArtefactsHeading2>
                         <AiOutlineMan/> Men's Costume
                    </ArtefactsHeading2>             
                   
                    <ArtefactWrapper>                
                        {PenanMenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
                    <ArtefactsHeading2> 
                        <AiOutlineWoman/> Women's Costumes 
                    </ArtefactsHeading2>
                     <ArtefactWrapper> 
                      {PenanWomenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>

                    <ArtefactsHeading1> 
                         <BsFillPersonFill/> Kelabit Traditional Costumes
                    </ArtefactsHeading1>
                    
                    <ArtefactsHeading2>
                         <AiOutlineMan/> Men's Costume
                    </ArtefactsHeading2>             
                   
                    <ArtefactWrapper>                
                        {KelabitMenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
                    <ArtefactsHeading2> 
                        <AiOutlineWoman/> Women's Costumes 
                    </ArtefactsHeading2>
                     <ArtefactWrapper> 
                      {KelabitWomenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>

                    <ArtefactsHeading1> 
                         <BsFillPersonFill/> Bisaya Traditional Costumes
                    </ArtefactsHeading1>
                    
                    <ArtefactsHeading2>
                         <AiOutlineMan/> Men's Costume
                    </ArtefactsHeading2>             
                   
                    <ArtefactWrapper>                
                        {BisayaMenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
                    <ArtefactsHeading2> 
                        <AiOutlineWoman/> Women's Costumes 
                    </ArtefactsHeading2>
                     <ArtefactWrapper> 
                      {BisayaWomenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>

                    <ArtefactsHeading1> 
                         <BsFillPersonFill/> Lun Bawang Traditional Costumes
                    </ArtefactsHeading1>
                    
                    <ArtefactsHeading2>
                         <AiOutlineMan/> Men's Costume
                    </ArtefactsHeading2>             
                   
                    <ArtefactWrapper>                
                        {LunBawangMenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
                    <ArtefactsHeading2> 
                        <AiOutlineWoman/> Women's Costumes 
                    </ArtefactsHeading2>
                     <ArtefactWrapper> 
                      {LunBawangWomenCostList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>

            </ArtefactsContainer>
    );
};

export default UluCostumes
